const de = {
  services: {
    seoTitle: "Services · Hotel Ciutat Martorell in Martorell",
    seoDesc: "Alle Hotel- und Zimmerservices: Business Corner, Restaurant My Bar, Parkplatz, Fitnessraum, kostenloses WLAN, 24h-Rezeption und vieles mehr.",
    eyebrow: "Services",
    title: "Alles, was Sie für einen komfortablen Aufenthalt brauchen",
    hotelTitle: "Hotel-Services",
    hotel: [
      "Klimaanlage und Heizung",
      "Aufzüge",
      "Tägliches Frühstücksbuffet",
      "Business Corner",
      "Gepäckaufbewahrung",
      "Fitnessraum",
      "Audiovisuelle Ausstattung",
      "Parkplatz",
      "24h-Rezeption",
      "Restaurant My Bar, täglich zum Mittag- und Abendessen geöffnet",
      "24h-Zimmerservice",
      "Tagungs- und Banketträume",
      "Wäscherei- / Reinigungsservice",
      "Druckservice",
      "Kostenloses WLAN",
    ],
    roomsTitle: "Im Zimmer",
    rooms: [
      "Barrierefrei für Gäste mit eingeschränkter Mobilität",
      "Individuelle Klimaanlage und Heizung",
      "Pflegeprodukte im Bad",
      "Komplettes Bad mit Dusche oder Badewanne und/oder Bidet",
      "Schreibtisch",
      "Minibar",
      "Haartrockner",
      "Flachbildfernseher mit USB-Anschluss",
      "Telefon im Zimmer und im Bad",
      "Kostenloses WLAN",
      "Babybett verfügbar",
      "Zustellbett",
      "Nichtraucherzimmer",
    ],
    fitness: {
      eyebrow: "Fitness",
      title: "Fitnessraum",
      text: "Bleiben Sie während Ihres Aufenthalts in Form – in unserem Fitnessraum mit Laufband, Heimtrainer und Hanteln.",
      alts: ["Fitnessraum mit Heimtrainer, Laufband und Handtüchern", "Fitnessraum mit Laufband, Fahrrad und Hanteln vor dem Spiegel"],
    },
    shop: {
      eyebrow: "Offizielle Fanartikel",
      title: "Fußballleidenschaft an der Rezeption",
      text: "An unserer Rezeption finden Sie offizielle Fanartikel des FC Barcelona und von Real Madrid. Nehmen Sie die Leidenschaft Ihres Teams mit nach Hause.",
      note: "Nur an der Rezeption erhältlich",
      cta: "Fragen Sie an der Rezeption",
      clubs: [
        { name: "FC Barcelona", items: "Trikots, Caps, Schals, Rucksäcke, Bälle und vieles mehr." },
        { name: "Real Madrid", items: "Trikots, Trikotsätze, Caps, Bälle, Schals und vieles mehr." },
      ],
    },
  },
  nav: {
    nye: "Silvester 2026",
    hotel: "Das Hotel",
    rooms: "Zimmer",
    services: "Services",
    corporate: "Firmen & Tagungen",
    events: "Events & Hochzeiten",
    restaurant: "Restaurant",
    location: "Lage",
    biosphere: "Nachhaltigkeit",
    gallery: "Galerie",
    blog: "Blog",
    contact: "Kontakt",
    book: "Direkt buchen",
    menu: "Menü",
    close: "Schließen",
    call: "Anrufen",
    map: "Karte",
    bookShort: "Buchen",
  },
  hero: {
    availability: "Verfügbarkeit prüfen",
    checkin: "Anreise",
    checkout: "Abreise",
    adults: "Erwachsene",
    children: "Kinder",
    promo: "Promo-Code",
    promoPlaceholder: "Optional",
    bestPrice: "Bestpreisgarantie bei Buchung hier",
    scroll: "Scrollen",
  },
  attrs: [
    { t: "Bestpreisgarantie", d: "Bei Direktbuchung" },
    { t: "Flexible Stornierung", d: "Je nach Tarif" },
    { t: "Frühstücksbuffet", d: "06:30 bis 10:30 Uhr" },
    { t: "Privatparkplatz", d: "Mit Aufpreis, nach Verfügbarkeit" },
    { t: "100 m zu Renfe & FGC", d: "30 Min. nach Barcelona" },
  ],
  marquee: ["Martorell", "30 Min. Barcelona", "Montserrat", "Renfe & FGC 100 m entfernt", "SEAT-CUPRA-Geschäftsgebiet", "4-Sterne-Komfort", "92 Zimmer", "Direktbuchung"],
  home: {
    presEyebrow: "Das Hotel",
    stats: [
      { n: "92", l: "Standard-Zimmer" },
      { n: "100 m", l: "von Renfe und FGC" },
      { n: "30 Min.", l: "von Barcelona und dem Flughafen" },
      { n: "180", l: "Personen im Hauptsaal" },
    ],
    roomsEyebrow: "Zimmer",
    roomsTitle: "Erholung nach Maß",
    roomsText: "Zwei Zimmertypen für Geschäftsreisende, Familien und lange Aufenthalte.",
    roomsCta: "Alle Zimmer ansehen",
    from: "Ab",
    detail: "Details ansehen",
    corpEyebrow: "Firmen & Tagungen",
    corpTitle: "Ein Business-Hub|5 Minuten von SEAT-CUPRA",
    corpFeatures: ["3 Tagungsräume", "Bis zu 180 Personen", "WLAN-Verbindung und AV-Technik", "Coffee Breaks und Business-Lunches"],
    corpCta: "Angebot anfordern",
    corpSecondary: "Räume ansehen",
    restEyebrow: "Gastronomie",
    restCta: "Das Restaurant entdecken",
    locEyebrow: "Lage",
    locCta: "Anfahrt",
    galleryEyebrow: "Galerie",
    galleryCta: "Komplette Galerie ansehen",
    directEyebrow: "Direktbuchung",
    directTitle: "Hier zu buchen lohnt sich immer",
    directItems: [
      { t: "Bester Online-Preis", d: "Keine Agentur bietet Ihnen einen niedrigeren Tarif als unsere Website." },
      { t: "Flexible Bedingungen", d: "Tarife mit kostenloser Stornierung und Zahlung im Hotel." },
      { t: "Direkter Kontakt", d: "Sie sprechen mit dem Hotelteam, ohne Vermittler, vor und nach Ihrem Aufenthalt." },
      { t: "Willkommens-Extras", d: "Später Check-out je nach Verfügbarkeit und exklusive Vorteile für Direktgäste." },
    ],
    testimonialsEyebrow: "Bewertungen",
    testimonials: [
      { q: "Perfekte Lage zum Arbeiten im Industriegebiet. Ruhige Zimmer und ein komplettes Frühstück. Wir kommen jeden Monat wieder.", a: "Marc V.", r: "Geschäftsreise" },
      { q: "Wir haben die Kommunion unserer Tochter im Saal gefeiert und alles war makellos. Das Team kümmerte sich um jedes Detail.", a: "Laura & Jordi", r: "Familienfeier" },
      { q: "Zug 2 Minuten zu Fuß und Barcelona in einer halben Stunde. Eine ruhige, gepflegte Basis, um die Stadt und Montserrat zu besuchen.", a: "Claire D.", r: "Kurztrip" },
    ],
    contactEyebrow: "Sprechen wir",
    contactCta: "Kontakt aufnehmen",
    rfpCta: "Angebot anfordern",
  },
  rooms: {
    eyebrow: "Zimmer",
    surface: "Größe",
    occupancy: "Belegung",
    bed: "Bett",
    bath: "Bad",
    features: "Ausstattung",
    guests: "Personen",
    book: "Dieses Zimmer buchen",
    all: "Alle Zimmer",
    photosEyebrow: "Galerie",
    photosTitle: "Zimmer & Bad",
    photosCount: "Fotos",
    featureLabels: {
      wifi: "Highspeed-WLAN",
      ac: "Klimaanlage",
      tv: "TV",
      desk: "Arbeitsschreibtisch",
      minibar: "Minibar",
      hairdryer: "Haartrockner",
      crib: "Babybett verfügbar",
      extra_bed: "Zustellbett",
      accessible: "Barrierefrei",
      nonsmoking: "Nichtraucher",
    },
    servicesEyebrow: "Services",
    family: {
      eyebrow: "Mit der Familie unterwegs",
      title: "Optionen für Familien",
      beds: { t: "Zustellbett (Dreibett)", d: "Machen Sie Ihr Zimmer mit einem Zustellbett zum Dreibettzimmer. Kostenlos für Kinder unter 12 Jahren." },
      crib: { t: "Gratis-Babybett", d: "Babybetten kostenlos für die Kleinsten verfügbar." },
      note: "Beide Optionen je nach Verfügbarkeit; bitte bei der Buchung frühzeitig anfragen.",
    },
    servicesTitle: "Wir haben alles, was Sie brauchen",
    services: [
      { t: "Frühstücksbuffet", d: "Regionale Produkte, hausgemachtes Gebäck und gesunde Optionen jeden Morgen." },
      { t: "Privatparkplatz", d: "Gegen Aufpreis, nach Verfügbarkeit." },
      { t: "Glasfaser-WLAN", d: "Symmetrische Verbindung im ganzen Hotel, ohne Aufpreis." },
      { t: "24-h-Rezeption", d: "Team jederzeit verfügbar für alles, was Sie brauchen." },
      { t: "Fitnessraum", d: "Halten Sie Ihre Routine während Ihres Aufenthalts." },
      { t: "Restaurant & Bar", d: "Business-Menü, mediterrane Karte und entspannte Drinks." },
    ],
    notFound: "Zimmer nicht gefunden",
  },
  corporate: {
    eyebrow: "Firmen",
    title: "Ihre Operationsbasis im Industriekorridor des Llobregat",
    pillars: [
      { t: "Firmentarife", d: "Ausgehandelte Preise für Unternehmen mit häufigen Aufenthalten und zentraler Abrechnung." },
      { t: "Tagungsräume", d: "Drei modulare Räume, von 12 bis 180 Personen." },
      { t: "Arbeiten und ausruhen", d: "Schreibtisch in jedem Zimmer, WLAN und frühes Frühstück." },
      { t: "Business-Catering", d: "Coffee Breaks, Arbeitsessen und Team-Dinner im Hotel." },
    ],
    salasEyebrow: "Tagungsräume",
    photosTitle: "Raum & Veranstaltungen",
    salasTitle: "Räume, die sich Ihrem Zeitplan anpassen",
    salasCta: "Alle Räume und Kapazitäten ansehen",
    formEyebrow: "Firmentarif",
    formTitle: "Fordern Sie Ihren Firmentarif an",
    formText: "Sagen Sie uns, wie viele Nächte pro Jahr Ihr Team benötigt, und wir erstellen Ihnen innerhalb von 24 Stunden ein Angebot.",
    capacityTitle: "Kapazitäten nach Bestuhlung",
    capacityLabels: { teatro: "Theater", escuela: "Schulung", u: "U-Form", imperial: "Konferenz", coctel: "Empfang", banquete: "Bankett" },
    equipmentLabels: {
      wifi: "Glasfaser-WLAN", proyector: "Beamer & Leinwand", flipchart: "Flipchart", pizarra: "Whiteboard",
      coffee_break: "Coffee Break", agua: "Mineralwasser", escritura: "Schreibmaterial", luz_natural: "Tageslicht", panelable: "Teilbar",
    },
    area: "Fläche",
    people: "Pers.",
    upTo: "Bis zu",
    requestRoom: "Angebot für diesen Raum anfordern",
    salasIntro: "Alle Räume verfügen über Glasfaser-WLAN, individuelle Klimatisierung, AV-Technik und Coffee-Break-Service. Wir helfen Ihnen, die ideale Bestuhlung zu wählen.",
    servicesTitle: "Services für Ihre Veranstaltung",
    services: ["Willkommens- und Vormittags-Coffee-Break", "Business-Lunch oder Arbeitsbuffet", "Unterkunft für Referenten und Teilnehmer", "Parkplatz für Teilnehmer", "Technischer Support während der Veranstaltung", "Sekretariat und Schreibmaterial"],
    otherRooms: "Weitere Räume",
    notFound: "Raum nicht gefunden",
  },
  events: {
    eyebrow: "Events & Feiern",
    title: "Große Tage verdienen einen passenden Ort",
    intro: "Hochzeiten, Kommunionen, Jubiläen und Gruppentreffen in einem 220 m² großen Saal mit Tageslicht, eigener Küche und 92 Zimmern, damit niemand zurückfahren muss.",
    types: [
      { key: "weddings", t: "Hochzeiten", d: "Bankette für bis zu 150 Gäste, Willkommenscocktail und kostenlose Hochzeitssuite.", cta: "Hochzeiten entdecken" },
      { key: "celebrations", t: "Feiern", d: "Kommunionen, Taufen, Geburtstage und Jubiläen mit maßgeschneiderten Menüs für jedes Alter.", cta: "Feiern ansehen" },
      { key: "groups", t: "Gruppen", d: "Sportteams, organisierte Reisen und Montserrat-Pilger mit Sonderkonditionen.", cta: "Gruppen & Reisen" },
    ],
    stepsEyebrow: "So gehen wir vor",
    steps: [
      { t: "Wir lernen uns kennen", d: "Besuch des Hotels, wir hören uns Ihre Idee an und schlagen Räume und Menüs vor." },
      { t: "Maßgeschneidertes Angebot", d: "Festes Angebot innerhalb von 48 h, ohne Überraschungen, mit Verkostung für Hochzeiten." },
      { t: "Der große Tag", d: "Ein engagierter Koordinator kümmert sich um Zeitpläne und Dienstleister, damit Sie nur genießen." },
    ],
    formEyebrow: "Erzählen Sie uns von Ihrer Veranstaltung",
    formTitle: "Lassen Sie uns mit der Planung beginnen",
    weddings: {
      title: "Hochzeiten in Martorell, eine halbe Stunde von Barcelona",
      intro: "Ein teilbarer Saal mit Tageslicht für das Bankett, eine Terrasse für den Cocktail und Zimmer für das Brautpaar und seine Gäste. Eigene mediterrane Küche und ein engagierter Koordinator vom ersten Kaffee bis zum letzten Tanz.",
      includes: ["Willkommenscocktail", "Bankett mit vorheriger Menüverkostung", "Kostenlose Hochzeitssuite", "Sonderpreise für Gäste", "Open Bar und DJ optional"],
    },
    celebrations: {
      title: "Kommunionen, Taufen und Jubiläen",
      intro: "Familienfeiern mit Menüs für Groß und Klein, Platz für Kinderanimation und der Ruhe, alles unter einem Dach zu haben.",
      includes: ["Kinder- und Erwachsenenmenüs", "Platz für Animation", "Maßgeschneiderte Dekoration", "Personalisierte Torte", "Fotobereich", "Zimmer für Angehörige"],
    },
    groups: {
      title: "Gruppen, Teams und organisierte Reisen",
      intro: "Unterkunft für Gruppen von 10 bis 180 Personen mit frühem Frühstück, Gruppendinner und schnellem Check-in. Der ideale Ausgangspunkt für Montserrat und Barcelona.",
      includes: ["Gruppentarife ab 10 Zimmern", "Frühes Frühstück auf Anfrage", "Gruppendinner und Picknicks", "Gruppen-Check-in"],
    },
    includesTitle: "Im Angebot enthalten",
    back: "Alle Events",
  },
  restaurant: {
    eyebrow: "My Bar",
    title: "Mediterrane Marktküche",
    hoursTitle: "Öffnungszeiten",
    breakfast: "Frühstück",
    lunch: "Mittagessen",
    dinner: "Abendessen",
    menuEyebrow: "Angebote",
    menus: [
      { t: "Frühstücksbuffet", d: "Hausgemachtes Gebäck, frisches Obst, katalanischer Aufschnitt, Eier à la minute und Spezialitätenkaffee.", p: "06:30 – 10:30" },
      { t: "Business-Menü", d: "Montag bis Freitag mittags. Drei Marktgänge mit Brot, Getränk und Kaffee.", p: "Preis auf Anfrage" },
      { t: "Mediterrane Karte", d: "Reisgerichte, Fisch des Tages, gegrilltes Fleisch und hausgemachte Desserts mit Penedès-Weinen.", p: "Abendessen und Wochenenden" },
      { t: "Gruppenmenüs", d: "Feste Vorschläge für Firmen, Feiern und Reisegruppen ab 10 Personen.", p: "Nach Maß" },
    ],
    reserveTitle: "Tisch reservieren",
    reserveText: "Rufen Sie uns an – wir bestätigen Ihren Tisch sofort.",
    reserveCta: "Restaurant anrufen",
    reserveTap: "Tippen zum Anrufen",
    wineEyebrow: "Weinkeller",
    wineTitle: "Weine aus dem Penedès und ganz Katalonien",
    wineText: "Eine kurze, ehrliche Karte, die kleine Weingüter der Region bevorzugt: Cavas, Xarel·los und Garnachas, die die saisonale Küche begleiten.",
  },
  location: {
    eyebrow: "Lage & Anbindung",
    title: "Im Zentrum von allem, was zählt",
    pois: [
      { name: "Bahnhof Renfe / FGC Martorell Enllaç", dist: "100 m", time: "2 Min. zu Fuß", mode: "walk" },
      { name: "SEAT-CUPRA-Zentrale und Industrieparks", dist: "2,5 km", time: "5 Min. mit dem Auto", mode: "car" },
      { name: "Kloster und Naturpark Montserrat", dist: "19 km", time: "20 Min. mit Auto / Zahnradbahn", mode: "car" },
      { name: "Zentrum von Barcelona (Pl. Espanya / Catalunya)", dist: "28 km", time: "30 Min. mit Direktzug oder A-2", mode: "train" },
      { name: "Flughafen Barcelona-El Prat (BCN)", dist: "32 km", time: "25 Min. über die Autobahn", mode: "plane" },
      { name: "Circuit de Barcelona-Catalunya", dist: "45 km", time: "40 Min. über die AP-7", mode: "car" },
    ],
    faqEyebrow: "Häufige Fragen",
    faqTitle: "Anfahrt und Fortbewegung",
    mapCta: "In Google Maps öffnen",
    addressTitle: "Adresse",
    transportTitle: "Verkehr",
    transportItems: [
      { t: "Mit dem Zug", d: "Renfe R4 und FGC (Martorell Enllaç / Martorell Central) 100 m entfernt. Barcelona in 30 Min." },
      { t: "Mit dem Auto", d: "Direkte Ausfahrten von der A-2 (Ausfahrt 585 Martorell) und der AP-7 (Ausfahrt 25 Martorell)." },
      { t: "Vom Flughafen", d: "25 Minuten über die Autobahn. Taxi oder Mietwagen empfohlen." },
    ],
  },
  gallery: {
    eyebrow: "Galerie",
    title: "Das Hotel in Bildern",
    all: "Alle",
    cats: { habitaciones: "Zimmer", restaurante: "Restaurant", salas: "Tagungsräume", eventos: "Events", fitness: "Fitnessraum", comunes: "Gemeinschaftsbereiche" },
  },
  blog: {
    eyebrow: "Blog & Guides",
    title: "Martorell, Barcelona und Montserrat in Ruhe",
    read: "Min. Lesezeit",
    readMore: "Artikel lesen",
    back: "Zurück zum Blog",
    related: "Verwandte Artikel",
    notFound: "Artikel nicht gefunden",
  },
  contact: {
    eyebrow: "Kontakt",
    title: "Sprechen wir über Ihren Aufenthalt oder Ihre Veranstaltung",
    text: "Wir antworten innerhalb von 24 Werkstunden. Für Zimmerbuchungen nutzen Sie bitte unsere Direktbuchungsmaschine mit Bestpreisgarantie.",
    phone: "Telefon",
    email: "E-Mail",
    address: "Adresse",
    hours: "24-Stunden-Rezeption",
    formEyebrow: "Formular",
    formTitle: "Wie können wir Ihnen helfen?",
  },
  form: {
    type: "Art der Anfrage",
    types: { contacto: "Allgemeine Anfrage", empresa: "Firmentarif", salas: "Angebot Räume / Tagungen", evento: "Hochzeit / Feier / Gruppe", restaurante: "Restaurantreservierung" },
    name: "Vor- und Nachname",
    company: "Firma / Organisation",
    email: "E-Mail",
    phone: "Telefon",
    nights: "Nächte pro Jahr (ca.)",
    guests: "Personen / Gäste",
    date: "Voraussichtliches Datum",
    attendees: "Anzahl der Teilnehmer",
    eventType: "Art der Veranstaltung",
    eventTypes: ["Hochzeit", "Kommunion / Taufe", "Jubiläum", "Besprechung / Schulung", "Kongress", "Reisegruppe", "Sonstiges"],
    setup: "Bevorzugte Bestuhlung",
    setups: ["Theater", "Schulung", "U-Form", "Konferenz", "Empfang", "Bankett"],
    catering: "Catering",
    caterings: ["Coffee Break", "Business-Lunch", "Abendessen", "Ohne Catering"],
    lodging: "Benötigen Sie eine Unterkunft?",
    lodgings: ["Ja", "Nein", "Zu bestätigen"],
    message: "Kommentare",
    messagePlaceholder: "Sagen Sie uns, was Sie brauchen…",
    consent: "Ich habe die Datenschutzrichtlinie gelesen und akzeptiere die Verarbeitung meiner Daten zur Bearbeitung dieser Anfrage.",
    submit: "Anfrage senden",
    sending: "Senden…",
    success: "Anfrage gesendet. Wir antworten innerhalb von 24 h.",
    error: "Senden fehlgeschlagen. Bitte erneut versuchen oder anrufen.",
    required: "Pflichtfeld",
    invalidEmail: "Ungültige E-Mail",
    consentRequired: "Sie müssen die Datenschutzrichtlinie akzeptieren",
    select: "Auswählen",
  },
  footer: {
    tagline: "4-Sterne-Hotel in Martorell. Erholung, Arbeit und Feiern 30 Minuten von Barcelona.",
    explore: "Entdecken",
    business: "Firmen",
    guides: "Ratgeber",
    legal: "Rechtliches",
    contact: "Kontakt",
    legalNotice: "Impressum",
    privacy: "Datenschutz",
    cookies: "Cookies",
    cookieSettings: "Cookie-Einstellungen",
    rights: "Alle Rechte vorbehalten.",
    registration: "Tourismusregister",
    newsletter: "Erhalten Sie Direktangebote",
    newsletterText: "Wir schreiben nur, wenn es etwas Lohnenswertes gibt.",
    subscribe: "Abonnieren",
    subscribed: "Danke, wir halten Sie auf dem Laufenden.",
    directBook: "Direktbuchung · Bestpreisgarantie",
  },
  legal: {
    legal: { title: "Impressum", date: "Oktober 2026", sections: [
      ["Identifikationsdaten", "In Übereinstimmung mit dem Gesetz 34/2002 vom 11. Juli über Dienste der Informationsgesellschaft und des elektronischen Geschäftsverkehrs (LSSI-CE) werden folgende Daten mitgeteilt:\nInhaber: EYE STAR, S.L.\nHandelsname: Hotel Ciutat Martorell\nSteuernummer (NIF): B87171740\nFirmensitz: Avda. de la Industria, 16, Edificio A, Local 207, 28760 Tres Cantos (Madrid), Spanien\nAnschrift des Betriebs: Avda. Pau Claris, s/n, 08760 Martorell (Barcelona), Spanien\nTelefon: +34 937 745 160\nE-Mail: info@hotel-martorell.com\nWebsite: www.hotel-martorell.com\nRegisterdaten: Handelsregister Madrid, Band 32963, Blatt 138, Registerblatt M-593334, 1. Eintragung."],
      ["Gegenstand", "Dieses Impressum regelt den Zugang, die Navigation und die Nutzung der Website www.hotel-martorell.com sowie die Verantwortlichkeiten, die sich aus der Nutzung ihrer Inhalte und gegebenenfalls der darüber angebotenen Dienste ergeben.\nDer Zugang zur und die Navigation auf der Website verleihen den Status eines Nutzers und bedeuten die Annahme der in diesem Impressum festgelegten Bedingungen."],
      ["Nutzungsbedingungen", "Der Nutzer verpflichtet sich, die Website im Einklang mit den geltenden Rechtsvorschriften, dem guten Glauben, der öffentlichen Ordnung und diesem Impressum zu nutzen.\nDer Nutzer hat es zu unterlassen, die Website für rechtswidrige oder diesem Impressum zuwiderlaufende Zwecke zu nutzen sowie Handlungen vorzunehmen, die die Website, ihre Inhalte oder die sie tragenden Systeme und Geräte beschädigen, unbrauchbar machen, überlasten oder beeinträchtigen könnten."],
      ["Geistiges und gewerbliches Eigentum", "Alle Inhalte der Website, einschließlich, beispielhaft und nicht abschließend, Texte, Fotografien, Bilder, Grafiken, Logos, Symbole, Design, Struktur, Quellcode und sonstige Elemente, die Teil der Website sind, stehen im Eigentum von EYE STAR, S.L. oder werden mit der entsprechenden Genehmigung ihrer rechtmäßigen Inhaber verwendet.\nDiese Inhalte sind durch die geltenden Vorschriften zum geistigen und gewerblichen Eigentum geschützt.\nDie Vervielfältigung, Verbreitung, öffentliche Wiedergabe, Umgestaltung oder jede andere Form der vollständigen oder teilweisen Verwertung der Inhalte der Website ohne vorherige ausdrückliche Genehmigung von EYE STAR, S.L. ist untersagt, außer in den gesetzlich zulässigen Fällen."],
      ["Haftung", "EYE STAR, S.L. ist bemüht, die Inhalte der Website korrekt und aktuell zu halten. Sie übernimmt jedoch keine Gewähr für das Fehlen von Fehlern oder Auslassungen und haftet nicht für Schäden, die sich aus der Nutzung der auf der Website enthaltenen Informationen ergeben können, wenn diese Folge von Umständen außerhalb ihrer Kontrolle sind.\nEYE STAR, S.L. übernimmt auch keine Gewähr für die Verfügbarkeit und Kontinuität des Betriebs der Website; es können Unterbrechungen aus technischen Gründen, aus Wartungsgründen oder aufgrund von Umständen außerhalb ihrer Kontrolle auftreten.\nDie Website kann Links zu Websites Dritter enthalten. EYE STAR, S.L. übernimmt keinerlei Verantwortung für die Inhalte, Dienste, den Betrieb oder die Datenschutzrichtlinien dieser externen Websites."],
      ["Schutz personenbezogener Daten", "Die Verarbeitung personenbezogener Daten, die über diese Website erhoben werden können, erfolgt gemäß den geltenden Vorschriften zum Schutz personenbezogener Daten.\nInformationen über den Verantwortlichen, die Zwecke der Verarbeitung, die Rechtsgrundlagen, die Empfänger, die Aufbewahrungsfristen und die Rechte, die Nutzer ausüben können, finden Sie in der Datenschutzrichtlinie der Website."],
      ["Cookies", "Diese Website kann Cookies und ähnliche Technologien verwenden.\nInformationen über die verwendeten Cookies, ihre Zwecke, etwaige beteiligte Dritte und die Art und Weise, wie der Nutzer seine Einstellungen verwalten kann, finden Sie in der Cookie-Richtlinie.\nNicht unbedingt erforderliche Cookies werden gemäß den geltenden Vorschriften und, sofern erforderlich, nach Einholung der Einwilligung des Nutzers verwendet."],
      ["Kommerzielle Mitteilungen", "Hat der Nutzer seine Einwilligung zum Erhalt kommerzieller Mitteilungen auf elektronischem Wege erteilt, so erfolgen diese gemäß den geltenden Rechtsvorschriften.\nDer Nutzer kann dem Versand kommerzieller Mitteilungen jederzeit über die in jeder Mitteilung dafür vorgesehenen Mechanismen widersprechen."],
      ["Änderungen", "EYE STAR, S.L. behält sich das Recht vor, die über die Website angebotenen Inhalte und Dienste sowie dieses Impressum jederzeit und ohne vorherige Ankündigung zu ändern, zu aktualisieren oder zu entfernen.\nDie Änderungen gelten ab dem Zeitpunkt ihrer Veröffentlichung auf der Website."],
      ["Anwendbares Recht und Gerichtsstand", "Das Verhältnis zwischen EYE STAR, S.L. und dem Nutzer unterliegt dem spanischen Recht.\nFür die Beilegung etwaiger Streitigkeiten im Zusammenhang mit dem Zugang zur oder der Nutzung der Website sind die nach den anwendbaren Vorschriften zuständigen Gerichte zuständig.\nHat der Nutzer die Eigenschaft eines Verbrauchers, werden die anwendbaren zwingenden Vorschriften über die gerichtliche Zuständigkeit und den Verbraucherschutz beachtet."],
    ]},
    privacy: { title: "Datenschutzrichtlinie", date: "18. Juli 2025", sections: [
      ["Verantwortlicher", "Firma: EYE STAR SL\nSteuernummer (NIF): B87171740\nDomain: https://www.hotel-martorell.com/\nPostanschrift: Avda. de la Industria 16, Edificio A, Local 207, 28760 Tres Cantos (Madrid)\nE-Mail: administracion@hotel-martorell.com\nTelefon: +34 937 745 160"],
      ["Datenschutz", "Gemäß den geltenden und anwendbaren Vorschriften zum Schutz personenbezogener Daten informieren wir Sie darüber, dass Ihre Daten in das Verarbeitungssystem im Eigentum von EYE STAR SL, mit Steuernummer B87171740 und Sitz in Avda. de la Industria 16, Edificio A, Local 207, 28760 Tres Cantos (Madrid), aufgenommen werden. Nachfolgend finden Sie die Informationen zu den durchgeführten Verarbeitungen."],
      ["Verwaltung von Online-Unterkunftsbuchungen", "Zweck: Erfassung und Verwaltung der Online-Unterkunftsbuchungen.\nAufbewahrungsfrist: 3 Jahre (Verordnung INT/1922/2003 vom 3. Juli über Registerbücher und Meldescheine von Reisenden in Beherbergungsbetrieben und ähnlichen Einrichtungen).\nRechtsgrundlage: die Einwilligung des Betroffenen.\nBasisdaten: Vor- und Nachname, Telefon, Steuernummer, E-Mail, Wirtschafts- oder Versicherungsdaten.\nSensible Daten: Daten über Minderjährige.\nWeitergaben: Ihre Daten werden bei Bedarf an die Steuerbehörde, Banken und Sparkassen, Sicherheitskräfte und die zuständigen Behörden weitergegeben, um die in den geltenden Vorschriften festgelegten Verwaltungs- und Sicherheitspflichten zu erfüllen. Rechtsgrundlage der Weitergabe ist die Erfüllung einer gesetzlichen Pflicht."],
      ["Werbemaßnahmen (Webformular)", "Zweck: Erhebung, Erfassung und Verarbeitung von Daten zur Bearbeitung Ihrer Anfragen und/oder Wünsche sowie zu Werbung und kommerzieller Akquise.\nAufbewahrungsfrist: solange die Einwilligung aufrechterhalten wird, außer bei gesetzlicher Verpflichtung.\nRechtsgrundlage: die Einwilligung des Betroffenen.\nBasisdaten: Vor- und Nachname, E-Mail."],
      ["Verwaltung von Website-Nutzern", "Zweck: Erhebung, Erfassung und Verarbeitung der Nutzerdaten.\nAufbewahrungsfrist: solange die Einwilligung aufrechterhalten wird, außer bei gesetzlicher Verpflichtung.\nRechtsgrundlage: die Einwilligung des Betroffenen.\nBasisdaten: Vor- und Nachname, E-Mail."],
      ["Installation von Cookies", "Zweck: Verwaltung und Installation der Cookies.\nAufbewahrungsfrist: solange die Einwilligung aufrechterhalten wird.\nRechtsgrundlage: die Einwilligung des Betroffenen.\nBasisdaten: E-Mail, IP-Adresse."],
      ["Newsletter", "Zweck: Verwaltung des Newsletter-Abonnements zur Durchführung der entsprechenden Versände.\nAufbewahrungsfrist: solange die Einwilligung aufrechterhalten wird.\nRechtsgrundlage: die Einwilligung des Betroffenen.\nBasisdaten: Vor- und Nachname, E-Mail."],
      ["Verwaltung des Webformulars", "Zweck: Bearbeitung Ihrer Anfragen und/oder Wünsche.\nAufbewahrungsfrist: solange die Einwilligung aufrechterhalten wird.\nRechtsgrundlage: die Einwilligung des Betroffenen.\nBasisdaten: Vor- und Nachname, E-Mail, IP-Adresse."],
      ["Rechte der Betroffenen", "Sie können Ihre Rechte auf Zugang, Berichtigung, Einschränkung, Löschung, Übertragbarkeit und Widerspruch gegen die Verarbeitung Ihrer personenbezogenen Daten ausüben sowie das Recht, nicht Gegenstand automatisierter Entscheidungen (einschließlich Profiling) zu sein, und die erteilte Einwilligung widerrufen:\n• Zugang: Bestätigung darüber erhalten, ob Ihre Daten verarbeitet werden, und ggf. die konkreten Daten sowie die rechtlichen Informationen zur Verarbeitung.\n• Berichtigung: unrichtige oder unvollständige Daten berichtigen lassen.\n• Einschränkung: die Zwecke der Verarbeitung in bestimmten Fällen einschränken lassen.\n• Löschung: Ihre Daten löschen lassen, mit Ausnahme der in der DSGVO vorgesehenen Fälle.\n• Übertragbarkeit: Ihre Daten in einem strukturierten, gängigen und maschinenlesbaren Format erhalten und an einen anderen Verantwortlichen übermitteln.\n• Widerspruch: dass Ihre Daten nicht verarbeitet werden oder ihre Verarbeitung in den vorgesehenen Fällen eingestellt wird.\n• Nicht Gegenstand automatisierter Entscheidungen, einschließlich Profiling, zu sein.\n• Widerruf der Einwilligung: jederzeit und kostenlos."],
      ["Ausübung der Rechte", "Zur Ausübung dieser Rechte können Sie ein Schreiben an Avda. de la Industria 16, Edificio A, Local 207, 28760 Tres Cantos (Madrid), zu Händen von EYE STAR SL, richten oder eine E-Mail an administracion@hotel-martorell.com senden. Der Betroffene muss sich zuverlässig identifizieren; bei Zweifeln an seiner Identität kann er aufgefordert werden, den Antrag zu ergänzen. Der Antrag kann von einem ordnungsgemäß identifizierten und bevollmächtigten gesetzlichen oder freiwilligen Vertreter gestellt werden. Es ist das Recht bzw. sind die Rechte anzugeben, die ausgeübt werden sollen, sowie eine Adresse für Benachrichtigungen und die erforderlichen Nachweisdokumente. Informationen werden niemals telefonisch erteilt."],
      ["Beschwerde bei der Aufsichtsbehörde", "Sie haben das Recht, bei der spanischen Datenschutzbehörde (Agencia Española de Protección de Datos) Beschwerde einzulegen, wenn Sie der Ansicht sind, dass ein Sachverhalt einen Verstoß gegen die geltenden Datenschutzvorschriften darstellen könnte."],
      ["Sicherheitsmaßnahmen", "EYE STAR SL verpflichtet sich, die erforderlichen technischen und organisatorischen Maßnahmen entsprechend dem Risikoniveau der durchgeführten Verarbeitungen zu ergreifen, um die Integrität, Vertraulichkeit und Verfügbarkeit der Daten zu gewährleisten."],
    ]},
    cookies: { title: "Cookie-Richtlinie", sections: [
      ["Was sie sind", "Cookies sind kleine Dateien, die beim Surfen auf Ihrem Gerät gespeichert werden und es ermöglichen, Präferenzen zu speichern oder die Nutzung der Website zu messen."],
      ["Cookies, die wir verwenden", "Technische Cookies, die für den Betrieb notwendig sind (Sprache, Admin-Sitzung und das Speichern Ihrer Cookie-Entscheidung), sowie – nur mit Ihrer Zustimmung – Analyse-Cookies von Google Analytics 4 (_ga, _ga_*; maximale Dauer 13 Monate) mit anonymisierter IP, um die Nutzung der Website zu verstehen und zu verbessern."],
      ["Dritte", "Die eingebettete Google-Maps-Karte und die externe Buchungsmaschine können ihre eigenen Cookies installieren, die ihren Richtlinien unterliegen."],
      ["Verwaltung", "Sie können Ihren Browser so konfigurieren, dass er Cookies blockiert oder löscht. Dies kann einige Funktionen der Website beeinträchtigen."],
      ["Ihre Einwilligung verwalten", "Beim ersten Besuch können Sie Cookies akzeptieren, ablehnen oder nach Kategorien einstellen. Ihre Wahl können Sie jederzeit über den Link „Cookie-Einstellungen“ in der Fußzeile ändern. Wenn Sie Analyse-Cookies ablehnen, läuft Google Analytics ohne Cookies (Consent Mode) und erhält nur anonyme Signale."],
    ]},
    updated: "Zuletzt aktualisiert",
  },
  consent: {
    eyebrow: "Cookies",
    title: "Ihre Privatsphäre, Ihre Entscheidung",
    text: "Wir verwenden notwendige eigene Cookies und – nur mit Ihrer Zustimmung – Analyse-Cookies (Google Analytics), um die Nutzung der Website zu verstehen und sie zu verbessern. Ihre Wahl können Sie jederzeit über „Cookie-Einstellungen“ in der Fußzeile ändern.",
    more: "Cookie-Richtlinie",
    acceptAll: "Alle akzeptieren",
    reject: "Ablehnen",
    configure: "Einstellen",
    save: "Auswahl speichern",
    close: "Schließen",
    always: "Immer aktiv",
    necessary: { t: "Notwendig", d: "Unverzichtbar für den Betrieb der Website: Sprache, Sicherheit und das Speichern Ihrer Cookie-Entscheidung." },
    analytics: { t: "Analyse", d: "Google Analytics mit anonymisierter IP, um Besuche zu messen und die Website zu verbessern. Bei Ablehnung werden nur anonyme Signale ohne Cookies gesendet." },
    marketing: { t: "Marketing", d: "Zur Messung von Kampagnen und Personalisierung von Google-Anzeigen. Derzeit verwenden wir keine Cookies dieser Art." },
  },
  notFound: { title: "Seite nicht gefunden", text: "Die gesuchte Seite existiert nicht oder wurde verschoben.", cta: "Zurück zur Startseite" },
  chat: {
    open: "Hotel-Assistent",
    close: "Schließen",
    title: "Hotel-Assistent",
    subtitle: "Sofortige Antworten, rund um die Uhr",
    intro: "Hallo, ich bin der virtuelle Assistent des Hotel Ciutat Martorell. Fragen Sie mich zu Zimmern, Frühstück, Anfahrt, Tagungsräumen oder Veranstaltungen.",
    placeholder: "Ihre Frage…",
    send: "Senden",
    suggestions: ["Wann gibt es Frühstück?", "Wie komme ich von Barcelona hierher?", "Gibt es einen Parkplatz?"],
    human: "Möchten Sie lieber mit einer Person sprechen?",
    call: "Anrufen",
    whatsapp: "WhatsApp",
    book: "Buchen",
    error: "Ich kann gerade nicht antworten. Rufen Sie uns an unter",
    disclaimer: "Automatischer Assistent: Fehler sind möglich. Zum Buchen nutzen Sie bitte die Schaltfläche Buchen.",
  },
  admin: {
    googleLogin: "Mit Google anmelden",
    or: "oder",
    aiTranslate: "Mit KI aus dem ES übersetzen",
    login: "Zugang zum Panel",
    email: "E-Mail",
    password: "Passwort",
    enter: "Anmelden",
    logout: "Abmelden",
    panel: "Inhalts-Panel",
    tabs: { nye: "Silvester", stats: "Statistiken", ai: "KI-Assistent", leads: "Anfragen", content: "Texte", rooms: "Zimmer", meeting: "Räume", faqs: "FAQ", gallery: "Galerie", blog: "Blog", survey: "Nachhaltigkeit", settings: "Hoteldaten" },
    save: "Speichern",
    saved: "Gespeichert",
    add: "Hinzufügen",
    delete: "Löschen",
    status: { nuevo: "Neu", en_proceso: "In Bearbeitung", cerrado: "Geschlossen" },
    noLeads: "Noch keine Anfragen.",
    resend: "Hinweis erneut senden",
    resendOk: "Hinweis erneut gesendet an",
    resendFail: "Der Hinweis konnte nicht gesendet werden",
    notifySent: "E-Mail-Hinweis gesendet",
    notifyFailed: "E-Mail-Hinweis fehlgeschlagen",
    notifyUnknown: "Kein Versandprotokoll",
  },
  common: {
    seeMore: "Mehr ansehen",
    bookNow: "Jetzt buchen",
    call: "Hotel anrufen",
    placeholderNote: "Vorläufiges Foto",
  },
  pages: {
    rooms: {
      seoTitle: "Zimmer in Martorell · Doppel- und Twin-Zimmer mit 21 m²",
      seoDesc: "Doppel- und Twin-Zimmer mit Glasfaser-WLAN, Schreibtisch und Frühstücksbuffet. Doppel und Twin. Direkt zum besten Preis buchen.",
      heroTitle: ["Zimmer, gemacht", "für echte Erholung"],
      heroText: "92 Zimmer für die absolute Erholung von Geschäfts- und Freizeitreisenden.",
    },
    roomDetailSuffix: "Zimmer",
    corporate: {
      seoTitle: "Business-Hotel und Tagungsräume in Martorell",
      seoDesc: "Firmentarife, 3 Tagungsräume für bis zu 180 Personen und Unterkunft 5 Min. von SEAT-CUPRA und den Industriegebieten von Martorell. Angebot in 24 h.",
      heroTitle: ["Ihre Operationsbasis", "im Llobregat-Korridor"],
    },
    meetingRooms: {
      seoTitle: "Tagungs- und Veranstaltungsräume in Martorell",
      seoDesc: "3 Räume mit Tageslicht von 35 bis 220 m² für Meetings, Schulungen und Kongresse von 12 bis 180 Personen. AV-Technik, Glasfaser und Coffee Break.",
      heroTitle: ["Drei Räume,", "unendliche Bestuhlungen"],
    },
    events: {
      seoTitle: "Hochzeiten, Feiern und Gruppen in Martorell",
      heroTitle: ["Große Tage verdienen", "einen passenden Ort"],
      stepsTitle: "Drei Schritte, null Sorgen",
    },
    restaurant: {
      seoTitle: "Restaurant in Martorell · Mediterrane Küche",
      heroTitle: ["Mediterrane", "Marktküche"],
    },
    location: {
      seoTitle: "Lage · Hotel in Martorell, 30 Min. von Barcelona",
      heroTitle: ["Im Zentrum von allem,", "was zählt"],
      distancesTitle: "Entfernungen und Zeiten",
    },
    gallery: {
      seoDesc: "Fotos des 4-Sterne-Hotels Ciutat Martorell in Martorell: Doppel- und Twin-Zimmer, Bäder, Tagungsräume, Bankettsaal, Restaurant My Bar, Gemeinschaftsbereiche und Umgebung.",
      biosphereNote: "Das Hotel Ciutat Martorell ist mit dem Biosphere-Zertifikat für nachhaltigen Tourismus ausgezeichnet. Alle unsere Nachhaltigkeitsmaßnahmen und -verpflichtungen finden Sie direkt in unserem offiziellen Profil.",
    },
    blog: { seoDesc: "Praktische Guides zu Martorell, Barcelona und Montserrat: Anreise mit Zug oder Auto, Sehenswertes, Restaurants und Tipps für Geschäftsreisende und Familien." },
    faq: { eyebrow: "Häufige Fragen", home: "Was Gäste uns oft fragen", rooms: "Zu den Zimmern", corporate: "Zu Tagungen und Geschäftsreisen", events: "Zu Hochzeiten, Feiern und Gruppen", restaurant: "Zum Restaurant" },
    biosphere: { seoTitle: "Nachhaltigkeit · Biosphere-Zertifizierung" },
    contact: { hoursValue: "Check-in 15:00 · Check-out 12:00" },
    seal: { sustainableTourism: "Nachhaltiger Tourismus", certifiedBy: "Zertifiziert von", viewCert: "Zertifizierung ansehen" },
    bookingCta: {
      eyebrow: "Direktbuchung",
      rooms: { title: "Zum garantiert besten Preis buchen", text: "Wenn Sie direkt auf der offiziellen Website buchen, erhalten Sie den besten Preis, ohne Zwischenhändler oder Provisionen." },
      location: { title: "30 Minuten von Barcelona und Montserrat", text: "Übernachten Sie neben den Bahnhöfen Renfe und FGC, mit dem Flughafen 30 Minuten entfernt. Direkt zum garantiert besten Preis buchen." },
    },
    blogPost: {
      sidebarTitle: "Schlafen Sie 100 m vom Zug",
      cta: {
        eyebrow: "Direktbuchung",
        secondary: "Angebot anfragen",
        transport: { title: "Schlafen Sie 100 m vom Zug", text: "Übernachten Sie neben den Bahnhöfen Renfe und FGC und erreichen Sie Barcelona in 30 Minuten. Bestpreis garantiert auf der offiziellen Website." },
        guides: { title: "Ihr Ausgangspunkt, um Martorell zu entdecken", text: "Barcelona, Montserrat und der Flughafen in 30 Minuten. Buchen Sie direkt und planen Sie Ihren Kurzurlaub." },
        business: { title: "Unterkunft und Tagungsräume für Ihr Unternehmen", text: "5 Minuten vom Industriegebiet entfernt, mit Tagungsräumen und Firmentarif. Fragen Sie uns nach einem maßgeschneiderten Angebot." },
        default: { title: "Buchen Sie Ihren Aufenthalt in Martorell", text: "4★-Hotel 30 Minuten von Barcelona. Bestpreis garantiert bei Direktbuchung." },
      },
    },
    homeHeadings: {
      presentation: ["4-Sterne-Hotel in Martorell.", "Erholung, Arbeit und Feiern", "30 Minuten von Barcelona."],
      gastronomy: ["Mediterrane Marktküche,", "ganz ohne Eile"],
      extras: ["Ein Event, ein Meeting", "oder ein langer Aufenthalt?"],
      heroRooms: "Zimmer",
    },
  },
};

export default de;
